import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Clock, ShieldCheck, Activity, Home } from "lucide-react";
import { Logo } from "@/components/Logo";
import { LegalFooter } from "@/components/LegalFooter";

const FEATURES = [
  { icon: Clock, text: "Validation sous 24h" },
  { icon: ShieldCheck, text: "Artisan certifié assigné" },
  { icon: Activity, text: "Suivi en direct de votre demande" },
];

export default function Confirmation() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const reference = state?.reference;
  const name = state?.name;

  return (
    <div className="min-h-screen bg-[#0B1E4D] flex flex-col" data-testid="request-confirmation-view">
      <header className="max-w-7xl w-full mx-auto px-5 sm:px-8 h-20 flex items-center">
        <button onClick={() => navigate("/")} className="flex items-center">
          <Logo flagClass="h-8" textClass="text-xl" boxed />
        </button>
      </header>

      <main className="flex-1 grid place-items-center px-5 py-12">
        <div className="w-full max-w-lg bg-white rounded-3xl shadow-2xl border border-slate-200 p-8 sm:p-10 text-center">
          <div className="mx-auto h-20 w-20 rounded-full bg-emerald-100 grid place-items-center">
            <CheckCircle2 className="h-11 w-11 text-emerald-600" />
          </div>
          <h1 className="font-display mt-6 text-3xl font-extrabold tracking-tight text-slate-900">
            Demande transmise avec succès !
          </h1>
          <p className="mt-3 text-slate-600 leading-relaxed">
            {name ? `Merci ${name}, votre` : "Votre"} dossier a été enregistré. Notre équipe présélectionne l'artisan idéal dans votre secteur.
          </p>

          {reference && (
            <div className="mt-6 rounded-xl bg-slate-50 border border-slate-200 py-4">
              <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Votre référence</p>
              <p className="font-mono-nums text-2xl font-bold text-blue-600 mt-1" data-testid="confirmation-reference">{reference}</p>
            </div>
          )}

          <div className="mt-6 space-y-3 text-left">
            {FEATURES.map((f) => (
              <div key={f.text} className="flex items-center gap-3 rounded-lg bg-white border border-slate-100 px-4 py-3">
                <f.icon className="h-5 w-5 text-blue-600 shrink-0" />
                <span className="text-sm font-medium text-slate-700">{f.text}</span>
              </div>
            ))}
          </div>

          <Button onClick={() => navigate("/")} className="mt-8 w-full h-12 bg-[#0B1E4D] hover:bg-[#0a1840] font-semibold" data-testid="back-home-button">
            <Home className="h-4 w-4 mr-2" /> Retour à l'accueil
          </Button>
          {reference && (
            <Button onClick={() => navigate(`/suivi/${reference}`)} variant="outline" className="mt-3 w-full h-12 border-slate-300 font-semibold" data-testid="track-request-button">
              <Activity className="h-4 w-4 mr-2" /> Suivre ma demande en direct
            </Button>
          )}
        </div>
      </main>
      <LegalFooter />
    </div>
  );
}
